import get from 'lodash/get'
import type { Holding } from './components/portfolio.data'
import { isTxaiFund } from './txaiInvalidSlices'

const MARKETPLACE_COLLECTION_PATH = '/marketplace/collection'

export function getMarketplaceCollectionAddress(
  holding: Pick<Holding, 'investmentNft'>,
  fundMeta?: unknown,
): string | null {
  const fromMeta =
    (get(fundMeta, 'marketplace.investmentAddress') as string | undefined) ||
    (get(fundMeta, 'attributes.marketplace.investmentAddress') as string | undefined)

  const address = (fromMeta || holding.investmentNft || '').trim()
  return address || null
}

export function getMarketplaceCollectionHref(
  holding: Pick<Holding, 'investmentNft'>,
  fundMeta?: unknown,
): string | null {
  const contractAddress = getMarketplaceCollectionAddress(holding, fundMeta)
  if (!contractAddress) return null

  return `${MARKETPLACE_COLLECTION_PATH}/${contractAddress}`
}

export function getHoldingBuyMoreHref(
  holding: Pick<Holding, 'investmentNft' | 'fundUrlId'>,
  fundMeta?: unknown,
): string | null {
  if (isTxaiFund(holding.fundUrlId, holding.investmentNft)) return null

  const stage = (get(fundMeta, 'stage') ?? get(fundMeta, 'attributes.stage')) as
    | string
    | undefined
  if (stage?.toLowerCase() === 'paused') return null

  return getMarketplaceCollectionHref(holding, fundMeta)
}
